'use strict';
import {combineReducers} from 'redux';
import {
  AUTH_DATA_NAME,
  AUTH_MODAL_NAME,
  LOGIN_USER_NAME,
  REFRESH_USER_NAME,
  RESET_PASSWORD_NAME,
  SIGNUP_USER_NAME,
} from '../redux/state';
import {reactReduxModal as authModal} from '../redux/authModal';
import {loginUserRequest} from '../redux/loginUser';
import {refreshUserRequest} from '../redux/refreshUser';
import {resetPasswordRequest} from '../redux/resetPassword';
import {signupUserRequest} from '../redux/signupUser';
import {authData} from './authData';

export * from './state';

export const auth = combineReducers({
  [AUTH_DATA_NAME]: authData,
  [AUTH_MODAL_NAME]: authModal.reducers.reducer,
  [LOGIN_USER_NAME]: loginUserRequest.reducers.reducer,
  [REFRESH_USER_NAME]: refreshUserRequest.reducers.reducer,
  [RESET_PASSWORD_NAME]: resetPasswordRequest.reducers.reducer,
  [SIGNUP_USER_NAME]: signupUserRequest.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/auth/reducers/index.js